import { ReactComponent as TposLogo } from 'assets/nav/tposLogo.svg'
import styled from 'styled-components'

const StyledLogo = styled(TposLogo)`
  width: 44px;
  height: 36px;
  margin: 14px 30px;
  align-self: center;
`

const TruepillLogo = (): JSX.Element => {
  return <StyledLogo />
}

export default TruepillLogo
